import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import api from "../services/api";

const getLoginData = (response) => {
  const payload = response?.data || response || {};
  return {
    status: response?.status || payload?.status,
    token: payload?.token || response?.token,
    user: payload?.user || response?.user,
    message: response?.message || payload?.message,
  };
};

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    const userData = localStorage.getItem("user_data");

    if (!token || !userData) return;

    try {
      const user = JSON.parse(userData);
      if (user?.id && user?.client_id !== undefined && user?.client_id !== null) {
        navigate("/dashboard", { replace: true });
      }
    } catch {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_data");
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await api.login(username.trim(), password);
      const { status, token, user, message } = getLoginData(response);
      const loginSucceeded = status === "success" || Boolean(token && user);

      if (!loginSucceeded) {
        throw new Error(message || "Login failed. Check your credentials.");
      }

      if (!token || !user?.id || user?.client_id === undefined || user?.client_id === null) {
        throw new Error("The server returned incomplete login information.");
      }

      const client = {
        id: user.client_id,
        company_name: user.company_name || `Client ${user.client_id}`,
      };

      localStorage.setItem("auth_token", token);
      localStorage.setItem("user_data", JSON.stringify(user));
      localStorage.setItem("current_client", JSON.stringify(client));

      onLogin?.(user);
      navigate("/dashboard", { replace: true });
    } catch (loginError) {
      setError(loginError.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col sm={11} md={7} lg={5} xl={4}>
            <Card className="login-card border-0">
              <Card.Body className="p-4 p-md-5">
                <div className="text-center mb-4">
                  <div className="login-logo">SA</div>
                  <h1 className="h3 mb-2">Sales Analytics</h1>
                  <p className="text-muted mb-0">Sign in to your client portal</p>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter username"
                      value={username}
                      onChange={(event) => setUsername(event.target.value)}
                      autoComplete="username"
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      autoComplete="current-password"
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    variant="danger"
                    className="w-100"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" animation="border" className="me-2" />
                        Signing in…
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </Button>
                </Form>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
